import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowRight } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Mujeres que sienten que si ellas fallan, todo su mundo se desmorona.', 'Madres y profesionales agotadas de llevar la logística emocional de toda la familia.', "Mujeres que sienten culpa cada vez que intentan descansar o decir 'no'.", 'Perfeccionistas funcionales que proyectan éxito afuera pero sienten vacío adentro.'];
  const notForWho = ['Personas que buscan consejos de productividad para ser aún más eficientes.', 'Quienes no están dispuestas a soltar el control y dejar que otros se equivoquen.', 'Personas que buscan una solución médica para síntomas clínicos graves.'];
  const steps = [{
    title: 'Identifica',
    desc: 'Localizamos la carga invisible que estás cargando por otros.'
  }, {
    title: 'Desmonta',
    desc: "Aplicamos el método del 'No Sagrado' para recuperar tu tiempo."
  }, {
    title: 'Sana',
    desc: "Reconstruimos tu identidad fuera del rol de 'la que resuelve todo'."
  }];
  return <section className="space-y-20" data-id="element-1">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-3">
          <h3 className="text-2xl font-bold text-[#3D2B1F] font-serif" data-id="element-4">
            Para quién es esto
          </h3>
          <ul className="space-y-4" data-id="element-5">
            {forWho.map((item, i) => <li key={i} className="flex items-start" data-id="element-6">
                <Check className="w-5 h-5 text-[#8B9E7E] mt-1 mr-3 flex-shrink-0" data-id="element-7" />
                <span className="text-[#3D2B1F]/80 leading-relaxed" data-id="element-8">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-6 bg-white/50 p-6 rounded-2xl border border-[#3D2B1F]/5" data-id="element-9">
          <h3 className="text-2xl font-bold text-[#3D2B1F]/60 font-serif" data-id="element-10">
            Para quién NO es
          </h3>
          <ul className="space-y-4" data-id="element-11">
            {notForWho.map((item, i) => <li key={i} className="flex items-start" data-id="element-12">
                <X className="w-5 h-5 text-[#C4704B]/60 mt-1 mr-3 flex-shrink-0" data-id="element-13" />
                <span className="text-[#3D2B1F]/60 leading-relaxed" data-id="element-14">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>

      <div className="space-y-8" data-id="element-15">
        <h3 className="text-3xl font-bold text-[#3D2B1F] text-center font-serif" data-id="element-16">
          Cómo funciona
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-17">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative bg-white p-6 rounded-xl shadow-sm text-center border-t-4 border-[#C4704B]" data-id="element-18">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#C4704B] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-19">
                {index + 1}
              </div>
              <h4 className="text-xl font-bold text-[#3D2B1F] mt-4 mb-2" data-id="element-20">
                {step.title}
              </h4>
              <p className="text-[#3D2B1F]/70 text-sm" data-id="element-21">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}